import React from 'react';
import './blogs.css';
import { motion } from 'framer-motion';

const Blogs = () => {
  const blogs = [
    {
      id: 1,
      title: "My Journey in Web Development",
      author: "Priya R.",
      date: "March 15, 2024",
      content: "Starting my journey at Nice Computer Education was one of the best decisions I've made. The practical approach to learning web development helped me land my first job...",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
      category: "Web Development"
    },
    {
      id: 2,
      title: "From Beginner to Python Developer",
      author: "Rahul K.",
      date: "March 10, 2024",
      content: "Learning Python opened up countless opportunities for me. The structured curriculum and hands-on projects at Nice helped me understand complex concepts easily...",
      image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
      category: "Programming"
    },
    {
      id: 3,
      title: "Success in Data Science",
      author: "Sneha M.",
      date: "March 5, 2024",
      content: "The data science course equipped me with both theoretical knowledge and practical skills. The real-world projects helped me build a strong portfolio...",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
      category: "Data Science"
    }
  ];

  return (
    <section className="blogs" id="blogs">
      <motion.div 
        className="blogs-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2>Student Stories</h2>
        <p>Read about the experiences of our successful students</p>
      </motion.div>

      <div className="blogs-container">
        {blogs.map((blog, index) => (
          <motion.article 
            key={blog.id}
            className="blog-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2 }}
          >
            <div className="blog-image">
              <img src={blog.image} alt={blog.title} />
              <span className="blog-category">{blog.category}</span>
            </div>
            <div className="blog-content">
              <h3>{blog.title}</h3>
              <div className="blog-meta">
                <span>{blog.author}</span>
                <span>{blog.date}</span>
              </div>
              <p>{blog.content}</p>
              <button className="read-more">Read More</button>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default Blogs; 